import Styled, { css } from 'styled-components';
import merge from 'lodash/merge';

import {
  cssDeclaration,
  VALID_EDGE_STYLE_DATA,
  VALID_MEDIA_STYLES
} from '../Utils';
import { InlineTextLink } from '../Links/InlineTextLink';

import { IBannerCommonProps, IBannerTheme, VALID_BANNER_VARIANTS } from './common';

interface IStyledBannerProps extends IBannerCommonProps {
  marginProp?: VALID_EDGE_STYLE_DATA;
  orderProp?: VALID_MEDIA_STYLES;
  variant: string;
}

const StyledBanner = Styled.div<IStyledBannerProps>`
    display: flex;

    ${({
      alignSelf,
      flexBasis,
      flexGrow,
      flexShrink,
      marginProp,
      orderProp,
      theme: { themeTwo },
      variant,
    }) => {
      const bannerDefault = themeTwo.banner.info;
      const bannerVariant = themeTwo.banner[variant as VALID_BANNER_VARIANTS];
      const bannerStyles: IBannerTheme = merge({}, bannerDefault, bannerVariant);

      return css`
        /* background-color */ ${bannerStyles.font && cssDeclaration(themeTwo, 'background-color', bannerStyles.backgroundColor)};
        /* color */ ${bannerStyles.font && cssDeclaration(themeTwo, 'color', bannerStyles.font.color)};
        /* margin */ ${marginProp && cssDeclaration(themeTwo, 'margin', marginProp)};
        /* border */ ${cssDeclaration(themeTwo, 'border', bannerStyles.border)};
        /* padding */ ${cssDeclaration(themeTwo, 'padding', bannerStyles.padding)};
        /* align-self */ ${alignSelf && cssDeclaration(themeTwo, 'align-self', alignSelf)};
        /* flex-basis */ ${flexBasis && cssDeclaration(themeTwo, 'flex-basis', flexBasis)};
        /* flex-grow */ ${flexGrow && cssDeclaration(themeTwo, 'flex-grow', flexGrow)};
        /* flex-shrink */ ${flexShrink && cssDeclaration(themeTwo, 'flex-shrink', flexShrink)};
        /* order */ ${orderProp && cssDeclaration(themeTwo, 'order', orderProp)};

        ${InlineTextLink}:hover {
          /* color */
          ${bannerVariant && bannerVariant.inlineLink && bannerVariant.inlineLink.hoverColor &&
            cssDeclaration(themeTwo, 'color', bannerVariant.inlineLink.hoverColor)
          };
        }
      `;
    }}
  `;

export default StyledBanner;
